import React from "react";
import { BarChart3Icon, ClipboardCheckIcon, FileTextIcon, GitBranchIcon, LayoutGridIcon, PlusIcon } from "lucide-react";
import { SectionCta } from "../SectionCta";
import { tools } from "../../data/content";
const toolIcons = [ClipboardCheckIcon, GitBranchIcon, LayoutGridIcon, BarChart3Icon, FileTextIcon];
export function Tools() {
  return <section className="bg-cream px-4 py-16 sm:px-6 sm:py-24" aria-labelledby="tools-title" data-id="element-325" data-mp="2di6bo32yuldc">
      <div className="mx-auto max-w-3xl text-center" data-id="element-326" data-mp="28ko52jcf8i8i">
        <p className="text-sm font-bold uppercase tracking-wide text-brand" data-id="element-327" data-mp="23sd3zd5y2qed">More than theory</p>
        <h2 id="tools-title" className="mt-3 font-display text-[28px] font-black leading-tight text-ink sm:text-4xl" data-id="element-328" data-mp="1yt0iowuq1rdw">
          <span className="text-brand" data-id="element-329" data-mp="1tvi68whhwu15">30+</span> Practical Clinical Decision Tools
        </h2>
        <p className="mt-5 text-[17px] leading-relaxed text-muted" data-id="element-330" data-mp="1prtx49d7tqds">
          Throughout the six volumes, you'll find tools that help organize clinical information and support
          professional reasoning.
        </p>
      </div>

      <ul className="mx-auto mt-12 max-w-3xl divide-y divide-navy-900/10 overflow-hidden rounded-3xl bg-white ring-1 ring-navy-900/10" data-id="element-331" data-mp="1584zlfbk5hnd">
        {tools.map((t, i) => {
        const Icon = toolIcons[i];
        return <li key={t.title} className="flex gap-4 p-5 sm:p-6" data-id="element-332" data-mp="10ad1g3kbkzaq" data-mpi={i}>
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-navy-900 text-gold-400" data-id="element-333" data-mp="10amphllt0wds">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-334" data-mp="1ny4kdq0d8akz" />
              </span>
              <div data-id="element-335" data-mp="1swy1rtirwlqf">
                <h3 className="font-display text-lg font-extrabold leading-snug text-ink" data-id="element-336" data-mp="1ez9fqicyz8js">{t.title}</h3>
                <p className="mt-1 text-base leading-relaxed text-muted" data-id="element-337" data-mp="1jyce5jyg2gis">{t.body}</p>
              </div>
            </li>;
      })}
        <li className="flex items-center gap-4 bg-gold-400 p-5 sm:p-6" data-id="element-338" data-mp="3jb2016ujyc8">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-navy-950 text-gold-400" data-id="element-339" data-mp="8jqeyrn7v3to">
            <PlusIcon className="h-6 w-6" aria-hidden="true" data-id="element-340" data-mp="2a7bflsjbwmw2" />
          </span>
          <p className="font-display text-base font-extrabold leading-snug text-navy-950 sm:text-lg" data-id="element-341" data-mp="258rsvpwwv72n">
            Plus 25+ additional assessment sheets, visual references, planning templates, and decision aids.
          </p>
        </li>
      </ul>

      <SectionCta label="Get all 6 clinical volumes + 30+ tools" data-id="element-342" data-mp="1wgpuryabe2vj" />
    </section>;
}